module.exports = __webpack_public_path__ + "img/sen-login.56a637c9.svg";